import React from 'react';
import { Box, Grid } from 'wt-ui';

import CalendarRow from '../CalendarRow';
import CalendarDateRow from '../CalendarDateRow';

import underlyingList from '../../services/underlyingList';

const gridVailable = () =>
  typeof window !== 'undefined' && window.CSS && window.CSS.supports && window.CSS.supports('display', 'grid');

const TableHeader = () => {
  if (gridVailable()) {
    return (
      <Box pad="small" style={{}}>
        <Grid columns={['xsmall', 'flex', '250px']} direction="row">
          <Box size="xxsmall">Time (GMT)</Box>
          <Box>Event</Box>
          <Grid columns={['flex', '50px']}>
            <Grid columns={['1/3', '1/3', '1/3']}>
              <Box>Actual</Box>
              <Box>Previous</Box>
              <Box>Units</Box>
            </Grid>
            <Box />
          </Grid>
        </Grid>
      </Box>
    );
  }
  return (
    <Box pad="small" style={{}}>
      <Box background="transparent" direction="row" justify="between" gap="xsmall">
        <Box size="xxsmall">Time (GMT)</Box>
        <Box fill>Event</Box>
        <Box width="250px" background="transparent" direction="row" justify="between">
          <Box background="transparent" direction="row" gap="xsmall">
            <Box width="66.66px">Actual</Box>
            <Box width="66.66px">Previous</Box>
            <Box width="66.66px">Units</Box>
          </Box>
          <Box width="50px" />
        </Box>
      </Box>
    </Box>
  );
};

const eventBelongsToFilters = (filters) => (event) => {
  const aux = underlyingList.find((x) => x.name === event.enum.underlyings[0]);
  if (aux) {
    const group = filters.find((x) => x.name === aux.group);
    // console.log(group && group.selected);
    return group && group.selected;
  }
  return true;
};

const applyFilters = (events, filters) =>
  events
    .map((e) => {
      if (e.isParent) {
        return {
          ...e,
          children: e.children.filter(eventBelongsToFilters(filters)),
        };
      }
      return e;
    })
    .filter((e) => (e.isParent ? true : eventBelongsToFilters(filters)(e)));

const MainTable = ({ data, filters }) => {
  let date = null;

  return (
    <Box background="transparent" width="full">
      <TableHeader key="tableHeader" />
      {applyFilters(data, filters).map((event) => {
        const newDate = new Date(event.dt);
        const content = [];
        if (!date || date.getDate() !== newDate.getDate()) {
          content.push(<CalendarDateRow date={newDate} key={newDate * 1} />);
          date = newDate;
        }
        content.push(<CalendarRow key={event._id || event.name} event={event} />);
        return content;
      })}
    </Box>
  );
};

export default MainTable;
